/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{fromValues as r}from"../../../../core/libs/gl-matrix-2/factories/vec3f64.js";class s{constructor(r,s){this.vec3=r,this.id=s}}function t(t,o,c,e){return new s(r(t,o,c),e)}export{s as LocalOrigin,t as fromValues};
